// extracted by mini-css-extract-plugin
export default {"container":"styles_container__8P5bv","video_bg":"styles_video_bg__xOf3q","video_bg_shadow":"styles_video_bg_shadow__tRUPY"};